import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import type { ReactElement } from 'react';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router';

import useDebounce from '@swf/core/hooks/useDebounce';

import { useHomeGamesWidget } from '../../model';
import { MemberStatusesPerPage } from '../Club/Members/utils';

import { TXTMOB_Search_by_PokerStars_ID } from './SearchBy.messages.json';
import styles from './Table.scss';
import SearchIcon from './assets/search.svg';

export const MemberTypeProps = {
  approved: {
    statuses: MemberStatusesPerPage.Approved,
    memberType: 'approved'
  },
  blocked: {
    statuses: MemberStatusesPerPage.Blocked,
    memberType: 'blocked'
  },
  pending: {
    statuses: MemberStatusesPerPage.Pending,
    memberType: 'pending'
  }
};

export type MemberType = 'approved' | 'blocked' | 'pending';

interface Props {
  type: MemberType;
}

const SearchBy = ({ type }: Props): ReactElement => {
  const { clubId } = useParams<{ clubId: string }>();
  const { formatMessage } = useIntl();
  const [filterInput, setFilterInput] = useState<string>('');
  const { widgetDispatch } = useHomeGamesWidget();

  const fetchMembers = useDebounce((value: string) => {
    widgetDispatch.fetchClubMembers({
      clubId,
      statuses: MemberTypeProps[type].statuses,
      memberType: MemberTypeProps[type].memberType as MemberType,
      namePrefix: value.length >= 2 ? value : undefined
    });
  }, 400);

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.target.value || undefined;
    setFilterInput(value ?? '');
    fetchMembers(e.target.value);
  };

  return (
    <TextField
      classes={{ root: styles.search }}
      value={filterInput}
      onChange={handleFilterChange}
      placeholder={formatMessage(TXTMOB_Search_by_PokerStars_ID)}
      InputProps={{
        disableUnderline: true,
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon width="24" height="24" stroke="white" />
          </InputAdornment>
        )
      }}
    />
  );
};

export default SearchBy;
